import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  titleSubject = new Subject<string>();
  loadingSubject = new Subject<boolean>();

  loadingStateChanged = new Subject<boolean>();
  routeLoadingStateChanged = new Subject<boolean>();
  translationLoadingStateChanged = new Subject<boolean>();

  constructor(
    private snackbar: MatSnackBar,
  ) { }

  /**
   *
   * @param message Can be keys or custom string
   * @param isTranslated false by default, put to true if message is a key
   * @param ms 3000 by default
   * @param action null by default
   */
  showSnackbar(message: string, isTranslated = false, ms = 3000, action = null): void {

    this.snackbar.open(message, action as any, { duration: ms });

  }

  changeTitle(title: string): void {
    // this.title.setTitle(title);
    this.titleSubject.next(title);
  }
}
